var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { id: "split_fullscreen", fluid: "" } },
    [
      _c(
        "v-col",
        { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-5",
              attrs: { cols: "12", align: "center" },
            },
            [
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0 mb-3", attrs: { justify: "end" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { id: "transparent_btn", elevation: "0" },
                          on: { click: _vm.goDashboard },
                        },
                        [
                          _c("v-img", {
                            attrs: {
                              src: require("@/assets/images/video_fullscreen.png"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0" },
                [
                  _vm.viewCount === 4
                    ? _c(
                        "v-col",
                        {
                          key: _vm.view4,
                          staticClass: "ma-0 pa-0",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-2",
                              attrs: { justify: "center" },
                            },
                            _vm._l(2, function (item, index) {
                              return _c(
                                "v-col",
                                {
                                  key: index,
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "6" },
                                },
                                _vm._l(2, function (item_nest, index_nest) {
                                  return _c(
                                    "v-col",
                                    {
                                      key: index_nest,
                                      staticClass: "ma-0 pa-0",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _vm.checkSplitScreenCameraList(
                                        index,
                                        index_nest,
                                        2
                                      )
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "ma-0 pa-0 ml-1 mr-1 mb-2",
                                              staticStyle: {
                                                cursor: "pointer",
                                              },
                                              attrs: { id: "camera_4box" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.goVideoPlayer(
                                                    index_nest + 2 * index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: {
                                                    id: "camera_select_bottom_bar",
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getSplitName(
                                                          index,
                                                          index_nest,
                                                          2
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("video", {
                                                staticClass:
                                                  "ma-2 pa-0 video-js vjs-default-skin vjs-big-play-centered vjs-custom",
                                                staticStyle: {
                                                  "object-fit": "fill",
                                                  width: "100%",
                                                  height: "100%",
                                                },
                                                attrs: {
                                                  id:
                                                    "example-4-video" +
                                                    (index_nest + 2 * index),
                                                  width: "100%",
                                                  height: "100%",
                                                  muted: "",
                                                },
                                                domProps: { muted: true },
                                              }),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "ma-0 pa-0 ml-1 mr-1 mb-2",
                                              attrs: { id: "camera_4box" },
                                            },
                                            [
                                              _c("video", {
                                                staticClass:
                                                  "ma-2 pa-0 video-js vjs-default-skin vjs-big-play-centered vjs-custom",
                                                attrs: {
                                                  id:
                                                    "example-4-video" +
                                                    (index_nest + 2 * index),
                                                  width: "100%",
                                                  height: "100%",
                                                  muted: "",
                                                },
                                                domProps: { muted: true },
                                              }),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "video_grey_box",
                                                  staticStyle: {
                                                    display: "flex",
                                                  },
                                                  attrs: {
                                                    id:
                                                      "no-data-video" +
                                                      (index_nest + 2 * index),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.t("noData")) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.viewCount === 9
                    ? _c(
                        "v-col",
                        {
                          key: _vm.view9,
                          staticClass: "ma-0 pa-0",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-2",
                              attrs: { align: "center" },
                            },
                            _vm._l(3, function (item, index) {
                              return _c(
                                "v-col",
                                {
                                  key: index,
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "4" },
                                },
                                _vm._l(3, function (item_nest, index_nest) {
                                  return _c(
                                    "v-col",
                                    {
                                      key: index_nest,
                                      staticClass: "ma-0 pa-0 pr-1 pl-1 mb-2",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _vm.checkSplitScreenCameraList(
                                        index,
                                        index_nest,
                                        3
                                      )
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              staticStyle: {
                                                cursor: "pointer",
                                              },
                                              attrs: { id: "camera_9box" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.goVideoPlayer(
                                                    index_nest + 3 * index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: {
                                                    id: "camera_select_bottom_bar",
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getSplitName(
                                                          index,
                                                          index_nest,
                                                          3
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("video", {
                                                staticClass:
                                                  "ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom",
                                                staticStyle: {
                                                  "object-fit": "fill",
                                                  width: "100%",
                                                  height: "100%",
                                                },
                                                attrs: {
                                                  id:
                                                    "example-9-video" +
                                                    (index_nest + 3 * index),
                                                  width: "550",
                                                  height: "350",
                                                  muted: "",
                                                },
                                                domProps: { muted: true },
                                              }),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { id: "camera_9box" },
                                            },
                                            [
                                              _c("video", {
                                                staticClass:
                                                  "ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom",
                                                attrs: {
                                                  id:
                                                    "example-9-video" +
                                                    (index_nest + 3 * index),
                                                  muted: "",
                                                },
                                                domProps: { muted: true },
                                              }),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "video_grey_box",
                                                  staticStyle: {
                                                    display: "flex",
                                                  },
                                                  attrs: {
                                                    id:
                                                      "no-data-video" +
                                                      (index_nest + 3 * index),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.t("noData")) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.viewCount === 16
                    ? _c(
                        "v-col",
                        {
                          key: _vm.view16,
                          staticClass: "ma-0 pa-0",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-2",
                              attrs: { align: "center" },
                            },
                            _vm._l(4, function (item, index) {
                              return _c(
                                "v-col",
                                {
                                  key: index,
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "3" },
                                },
                                _vm._l(4, function (item_nest, index_nest) {
                                  return _c(
                                    "v-col",
                                    {
                                      key: index_nest,
                                      staticClass: "ma-0 pa-0 pr-1 pl-1 mb-2",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _vm.checkSplitScreenCameraList(
                                        index,
                                        index_nest,
                                        4
                                      )
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              staticStyle: {
                                                cursor: "pointer",
                                              },
                                              attrs: { id: "camera_16box" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.goVideoPlayer(
                                                    index_nest + 4 * index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: {
                                                    id: "camera_select_bottom_bar",
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getSplitName(
                                                          index,
                                                          index_nest,
                                                          4
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("video", {
                                                staticClass:
                                                  "ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom",
                                                staticStyle: {
                                                  "object-fit": "fill",
                                                  width: "100%",
                                                  height: "100%",
                                                },
                                                attrs: {
                                                  id:
                                                    "example-16-video" +
                                                    (index_nest + 4 * index),
                                                  width: "550",
                                                  height: "350",
                                                  muted: "",
                                                },
                                                domProps: { muted: true },
                                              }),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { id: "camera_16box" },
                                            },
                                            [
                                              _c("video", {
                                                staticClass:
                                                  "ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom",
                                                attrs: {
                                                  id:
                                                    "example-16-video" +
                                                    (index_nest + 4 * index),
                                                  muted: "",
                                                },
                                                domProps: { muted: true },
                                              }),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "video_grey_box",
                                                  staticStyle: {
                                                    display: "flex",
                                                  },
                                                  attrs: {
                                                    id:
                                                      "no-data-video" +
                                                      (index_nest + 4 * index),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.t("noData")) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("NameChangeDialog", {
        attrs: {
          dialogVisible: _vm.nameChangeDialogVisible,
          editType: _vm.editNameType,
          currentId: _vm.currentId,
          currentName: _vm.currentName,
        },
        on: {
          nameUpdate: _vm.nameUpdateFunc,
          visible: _vm.nameChangeDialogVisibleFunc,
        },
      }),
      _c("SearchCameraDialog", {
        attrs: { dialogVisible: _vm.searchCameraDialogVisible },
        on: {
          visible: _vm.searchCameraDialogVisibleFunc,
          selectCamera: _vm.selectCameraFunc,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }